export enum PdfAssignerDialogMessagesEnum {
    ToDeleteTitle = 'Are you sure you want to delete this pdf file?',
    AssignedPlaylistToDeleteTitle = 'The PDF playlist is already assigned.',
    WrongFileTypeSelectedTitle = 'Wrong file type',
    WrongFileTypeSelectedError = 'You can upload only \'.pdf\' files',

    WrongMonitorsTitle = 'Please re-name it according to the naming convention.',
    WrongMonitorsMachineAdress = 'Please select monitors only from the same location.',
    WrongMonitorsNamePrefix = 'A screens with the names',
    WrongMonitorsNameSuffix = 'was not assigned with playlist.',
    SuccessfullyUnAssigned = 'was successfully unassigned from ',
    SuccessfullyAssigned = 'was successfully assigned to ',
    PlaylistsSuccessfullyCreated = 'Your playlists are ready',

    PlaylistsSuccessfullyRun = 'successfully started',
    PlaylistsSuccessfullyRunWithADelay = 'successfully started with delay',
    PlaylistsSuccessfullyStopped = 'successfully stopped',
    PlaylistsForTitle = 'Playlists for',
    SavedWithoutChanges = 'was saved without any changes',

    PdfFileTitle = 'PDF file',
    PdfPlaylistDeletingTitle = 'PDF playlist deleting',
    PDFPlaylistCreationTitle = 'PDF Playlist creation',
    PDFPlaylistEditingTitle = 'PDF Playlist editing',

    CurrentTitleIsAlreadyExist = 'The current title is already exist',
    PDFPlaylistCanNotBeSaved = 'PDF playlist can not be saved',

    PdfMonitorTagMonitorsIsEmptyTitle = 'The monitors list is empty',
    PdfMonitorTagMonitorsIsEmptyError = 'Assign at least one monitor at first or ask the permission to the assigned monitors in your administrator.',

    MonitorTagInfoIsPlayingTitle = 'PDF playlist is playing',
    MonitorTagInfoIsPlayingDescription = 'You need to stop the playlist first',

    MonitorTagInfoIsAssignmentTitle = 'PDF playlist is assigned',
    MonitorTagInfoIsAssignmentgDescription = 'You need to clear the playlist assignment',

    EmptyMonitorsListTitle = 'There are no monitors acording to the rules',
    EmptyMonitorsListDescription = 'Check monitor name or correct machine.',

    PlaylistsWithDelayWillBeStarted = 'The playlists will be showing on the screens in few seconds',
    LicensePermissionDeniedTitle = 'PDF Assigner feature is not available for current license',

    PdfSettingsError = 'PDF settings error',
    InvalidPdfSettings = 'Invalid settings',

    SettingsSavedSuccess = 'Settings were saved successfully'
}
